"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DeleteOverlay = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _components = require("./components");

var _formElements = require("@evidation/form-elements");

var _react = _interopRequireDefault(require("react"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DeleteOverlay = function DeleteOverlay(_ref) {
  var overlay = _ref.overlay,
      onDelete = _ref.onDelete,
      toggleOverlayOn = _ref.toggleOverlayOn,
      toggleOverlayOff = _ref.toggleOverlayOff,
      name = _ref.name;
  return !overlay ? /*#__PURE__*/_react["default"].createElement(_components.DeleteImage, {
    onClick: toggleOverlayOn
  }, "X") : /*#__PURE__*/_react["default"].createElement(_components.DeleteImageOverlay, null, /*#__PURE__*/_react["default"].createElement(_components.RemoveHeading, null, "Remove this Image?"), /*#__PURE__*/_react["default"].createElement(_formElements.Button, {
    style: {
      padding: "0px"
    },
    buttonStyle: "achievement",
    onClick: function onClick() {
      return onDelete(name);
    }
  }, "Remove Image"), /*#__PURE__*/_react["default"].createElement(_formElements.Button, {
    buttonStyle: "achievement_text",
    onClick: toggleOverlayOff
  }, "Cancel"));
};

exports.DeleteOverlay = DeleteOverlay;

var Preview = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Preview, _React$PureComponent);

  var _super = _createSuper(Preview);

  function Preview(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Preview);
    _this = _super.call(this, props);
    _this.state = {
      overlay: false
    };
    return _this;
  }

  (0, _createClass2["default"])(Preview, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var overlay = this.state.overlay;
      var _this$props = this.props,
          onClick = _this$props.onClick,
          name = _this$props.name,
          disabled = _this$props.disabled,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["onClick", "name", "disabled"]);
      return /*#__PURE__*/_react["default"].createElement(_components.UploadPictureContainer, (0, _extends2["default"])({}, rest, {
        overlay: overlay
      }), !disabled && /*#__PURE__*/_react["default"].createElement(DeleteOverlay, {
        overlay: overlay,
        onDelete: onClick,
        toggleOverlayOn: function toggleOverlayOn() {
          return _this2.setState({
            overlay: true
          });
        },
        toggleOverlayOff: function toggleOverlayOff() {
          return _this2.setState({
            overlay: false
          });
        }
      }));
    }
  }]);
  return Preview;
}(_react["default"].PureComponent);

Preview.propTypes = {};
var _default = Preview;
exports["default"] = _default;